import { createAuthLoader } from "@shared-ui/loaders/auth-loader";
import { ENV } from "@/config/env";
import type { WhoamiMe } from "@shared-domain/auth-service/contract";

const AUTH_REFRESH = `${ENV.PRODUCT_API_ENDPOINT}/auth/refresh`;

export interface RootLoaderData {
  auth: WhoamiMe;
}

export async function rootLoader({
  request,
}: {
  request: Request;
}): Promise<RootLoaderData> {
  const url = new URL(request.url);

  if (url.pathname.includes("/403") || url.pathname.includes("/404")) {
    return {
      auth: {
        user: { id: "", name: "", email: "" },
        memberships: [],
        currentTenantId: "",
        info: undefined,
      } as WhoamiMe,
    };
  }

  const authLoader = createAuthLoader({
    apiEndpoint: ENV.PRODUCT_API_ENDPOINT,
    authPortalUrl: ENV.AUTH_PORTAL_URL,
    productId: ENV.PRODUCT_ID,
    tokenStoreName: "admin",
    userPoolId: ENV.COGNITO_USERPOOL_ID,
    clientId: ENV.CLIENT_ID,
    authRefreshUrl: AUTH_REFRESH,
  });

  const auth = await authLoader({ request });

  return { auth };
}
